import { SeMappableModel } from 'se-fe-service';
import { PriceSchedule } from './price-schedule.model';
import { PriceVariation } from './price-variation.model';

export class ItemVariation extends SeMappableModel {
  created_at: any;
  currency: string;
  full_name: string;
  id: number;
  item_id: number;
  name: string;
  price: string;
  price_cents: number;
  price_schedules: Partial<PriceSchedule>[];
  price_variations: Partial<PriceVariation>[];
  sku: string;
  sold_count?: number;
  tax_code?: string;
  tax_integration_attributes?: any;
  upfront_amount: string;
  upfront_amount_cents: number;
  uuid: string;
  zero_rate_type: number;
  reference_code: ReferenceCode | string;
}

export interface ReferenceCode {
  title?: string;
  tenant_id?: string;
  id?: string;
}
